import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

const ROWS = [
	{ mine: false, width: 220 },
	{ mine: true, width: 160 },
	{ mine: false, width: 180 },
	{ mine: true, width: 200 },
	{ mine: false, width: 140 },
];

export const ChatSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack gap={0.8} px={1.2} py={1.2}>
			{ROWS.map((row, index) => (
				<Skeleton
					// biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list
					key={index}
					variant="rounded"
					height={44}
					width={row.width}
					sx={{
						borderRadius: theme.radii.xl,
						alignSelf: row.mine ? "flex-end" : "flex-start",
					}}
				/>
			))}
		</Stack>
	);
};
